module.exports = __webpack_public_path__ + "static/media/notification.8aeb9c41.mp3";